import Checkbox from './Checkbox'
import clickCheckbox from './testHelper/clickCheckbox'
import expectCheckboxValue from './testHelper/expectCheckboxValue'
import expectCheckboxExists from './testHelper/expectCheckboxExists'
import expectCheckboxNotExists from './testHelper/expectCheckboxNotExists'

export default Checkbox

export { clickCheckbox, expectCheckboxValue, expectCheckboxExists, expectCheckboxNotExists }
